// extracted by mini-css-extract-plugin
export var component = "WastePickupSearch-module--component--xgMsy";
export var downloadButtonText = "WastePickupSearch-module--downloadButtonText--dNmFv";
export var fieldset = "WastePickupSearch-module--fieldset--f9RyF";
export var form = "WastePickupSearch-module--form--QoLS5";
export var submitBtn = "WastePickupSearch-module--submitBtn--XRB+f";
export var submitBtnLongText = "WastePickupSearch-module--submitBtnLongText---hs9P";